import { render, staticRenderFns } from "./EnergyPage.vue?vue&type=template&id=4ab22c1b&scoped=true&"
import script from "./EnergyPage.vue?vue&type=script&lang=js&"
export * from "./EnergyPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ab22c1b",
  null
  
)

export default component.exports